import Vue from 'vue'
import Vuex from 'vuex'
import enroll from './modules/enroll'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	state:{
        popupIds:[],//弹窗组件栈
		popupId:'',//弹窗组件唯一索引（popup组件占用）

		indexConH:0,//根容器高度
		menuIndex:0, //顶级菜单index
        
		mainMenuIndex:0, //顶级菜单index
		subMenuIndex:0,// 二级菜单的 index

		userManage:false, // 学校管理功能权限
		sendSchoolNotice:false,  	//全校通知的功能权限
		sendSchoolOffical:false, 	//微官网的功能
		sendSchoolRecipe:false,  	//全校菜谱的功能权限
		sendSchoolTiwen:false, 		//体温
		sendSchoolQingjia:false,
        screenManage:false
	},
	getters:{},
	mutations:{
        pushPopupId:(state,payload='')=>{
			if(!payload){
				return;
			}
			state.popupIds.push(payload);
			state.popupId = payload;
		},
		popPopupId:(state,payload='')=>{
			if(!payload||state.popupIds.length<=0){
				return;
			}
			if(payload==state.popupIds[state.popupIds.length-1]){
				var popupId = state.popupIds.pop();
				if(state.popupIds.length>0){
					state.popupId = state.popupIds[state.popupIds.length-1];
				}
			}
		},
		setIndexConH:(state,payload=0)=>{
			payload && (state.indexConH = payload);
		},
		setMainMenuIndex:(state,payload=0)=>{
			state.mainMenuIndex = payload;
		},
		setSubMenuIndex:(state,payload=0)=>{
			state.subMenuIndex = payload;
		},

		//权限的设置
		setOwnAuthority:(state,payload={})=>{
			console.log("##############setOwnAuthority##############");
			console.log(payload);
			let {userManage=true,sendSchoolNotice=true,sendSchoolCk=true,sendCollect=true,sendClassPerf=true,albumManage=true,
				sendAicomment=true,sendSchoolOffical=true,sendSchoolRecipe=true,sendScore=true,sendElect=true,screenManage=false} = payload;
			state.userManage = userManage;
			state.sendSchoolNotice = sendSchoolNotice;
			state.sendSchoolCk = sendSchoolCk;
			state.sendSchoolOffical = sendSchoolOffical;
			state.sendSchoolRecipe = sendSchoolRecipe;
			state.sendScore = sendScore;
			// state.sendElect = sendElect;
			// state.albumManage = albumManage;
			state.sendAicomment = sendAicomment;
			state.sendCollect = sendCollect;
			state.sendClassPerf = sendClassPerf;
			state.sendSchoolTiwen = true; //暂时默认都有这个功能
			state.sendSchoolQingjia = true;	//暂时默认都有这个功能
            state.screenManage = screenManage;
		}
	},
	actions:{},
	modules: {
		//enroll
	}
  // strict: debug
})


// WEBPACK FOOTER //
// ./src/store/index.js